(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chronoera-product-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('chronoera-product-details')) {
  class ChronoeraProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const source = this.querySelector('.ch-pdp-description');
      const table = this.querySelector('.ch-pdp-spec-table');
      if (!table?.tBodies[0]?.rows.length) this.querySelector('.ch-pdp-specifications')?.setAttribute('hidden', '');
      if (!source || !this.dataset.language?.startsWith('en')) return;
      try {
        this.organize(source, table);
      } catch {
        this.dataset.layout = 'original';
      }
    }

    textLines(node) {
      const clone = node.cloneNode(true);
      clone.querySelectorAll('br').forEach(el => el.replaceWith('\n'));
      clone.querySelectorAll('p,li,div,section,tr').forEach(el => el.append('\n'));
      return clone.textContent.split('\n').map(text => text.replace(/^[\s•·]+/, '').replace(/\s+/g, ' ').trim()).filter(Boolean);
    }

    organize(source, table) {
      const copy = source.cloneNode(true);
      const normalize = text => text.replace(/\s+/g, ' ').trim().toLowerCase().replace(/[’‘]/g, "'");
      const headingNodes = [...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p')];
      const heading = headingNodes.find(el => /^specifications:?$/.test(normalize(el.textContent)));
      if (!heading) return;
      const nextHeading = headingNodes.find(el => el !== heading && heading.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING && (/^h[1-6]$/i.test(el.tagName) || /^(why you(?:'ll| will) like it|additional information):?$/.test(normalize(el.textContent))));
      if (!nextHeading) return;
      const range = document.createRange();
      range.setStartAfter(heading);
      range.setEndBefore(nextHeading);
      const specs = document.createElement('div');
      specs.append(range.cloneContents());
      if (specs.querySelector('img,video,iframe,a,table')) return;
      const lines = this.textLines(specs);
      if (lines.length < 2 || lines.length > 60 || lines.some(line => line.length > 500)) return;
      const labels = JSON.parse(this.querySelector('[data-spec-labels]').textContent);
      const rows = new Map();
      const add = (key, label, value) => {
        if (!value) return;
        if (rows.has(key)) {
          if (!rows.get(key).values.includes(value)) rows.get(key).values.push(value);
        } else rows.set(key, { label, values: [value] });
      };
      const fallback = [...table.tBodies[0].rows].map(row => ({ key: row.dataset.specKey, label: row.cells[0].textContent.trim(), value: row.cells[1].textContent.trim() }));
      fallback.filter(row => ['brand', 'reference'].includes(row.key)).forEach(row => add(row.key, row.label, row.value));
      const keyMap = { diameter: 'case_size', 'case diameter': 'case_size', 'case size': 'case_size', thickness: 'thickness', 'case thickness': 'thickness', 'water resistance': 'water_resistance', movement: 'movement', 'dial colour': 'dial_color', 'dial color': 'dial_color', 'band colour': 'band', 'band color': 'band', reference: 'reference' };
      for (const line of lines) {
        const colon = line.indexOf(':');
        if (colon > 0 && colon < 55 && line.slice(colon + 1).trim()) {
          const rawLabel = line.slice(0, colon).trim();
          const key = keyMap[normalize(rawLabel)] || normalize(rawLabel);
          add(key, labels[key] || rawLabel, line.slice(colon + 1).trim());
          continue;
        }
        let key = 'featuress';
        if (/case\s*back/i.test(line)) key = 'case_back';
        else if (/\bclasp\b/i.test(line)) key = 'clasp';
        else if (/\bcrown\b/i.test(line)) key = 'crown';
        else if (/\bbezel\b/i.test(line)) key = 'bezel';
        else if (/\bmovement\b/i.test(line)) key = 'movement';
        else if (/\bdial\b/i.test(line)) key = 'dial';
        else if (/\bcrystal\b/i.test(line)) key = 'crystal';
        else if (/\bcase\b/i.test(line) && /bracelet|strap/i.test(line)) key = 'case_bracelet';
        else if (/\bcase\b/i.test(line)) key = 'case';
        else if (/bracelet|strap/i.test(line)) key = 'bracelet';
        add(key, labels[key], line);
      }
      fallback.forEach(row => {
        if (rows.has(row.key)) return;
        if (row.key === 'dial_color' && rows.has('dial')) return;
        if (row.key === 'featuress' && lines.some(line => /display|chronograph/i.test(line))) return;
        add(row.key, row.label, row.value);
      });
      const newBody = document.createElement('tbody');
      for (const [key, row] of rows) {
        const tr = document.createElement('tr');
        tr.dataset.specKey = key;
        const th = document.createElement('th');
        th.scope = 'row';
        th.textContent = row.label;
        const td = document.createElement('td');
        if (row.values.length === 1) td.textContent = row.values[0];
        else {
          const ul = document.createElement('ul');
          row.values.forEach(value => {
            const li = document.createElement('li');
            li.textContent = value;
            ul.append(li);
          });
          td.append(ul);
        }
        tr.append(th, td);
        newBody.append(tr);
      }
      range.deleteContents();
      heading.remove();
      const storyHeading = [...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p')].find(el => /^why you(?:'ll| will) like it:?$/.test(normalize(el.textContent)));
      storyHeading?.remove();
      const additional = [...copy.querySelectorAll('h1,h2,h3,h4,h5,h6,p')].find(el => /^additional information:?$/.test(normalize(el.textContent)));
      let extra;
      if (additional) {
        const extraRange = document.createRange();
        extraRange.setStartAfter(additional);
        extraRange.setEnd(copy, copy.childNodes.length);
        const extraContent = document.createElement('div');
        extraContent.append(extraRange.cloneContents());
        if (extraContent.textContent.trim()) {
          extra = document.createElement('details');
          extra.className = 'ch-pdp-extra';
          const summary = document.createElement('summary');
          summary.textContent = additional.textContent.trim();
          extraContent.className = 'ch-pdp-description rte';
          extra.append(summary, extraContent);
          extraRange.deleteContents();
          additional.remove();
        }
      }
      for (const tree of [copy, extra].filter(Boolean)) {
        tree.querySelectorAll('div,section,p,span,h1,h2,h3,h4,h5,h6,ul,li').forEach(el => {
          if (el !== extra?.lastElementChild) el.removeAttribute('class');
          el.removeAttribute('style');
          el.removeAttribute('align');
        });
      }
      source.replaceChildren(...copy.childNodes);
      if (!source.textContent.trim() && !source.querySelector('img,video') && !this.querySelector('.ch-pdp-model-intro')) this.querySelector('.ch-pdp-overview').hidden = true;
      table.tBodies[0].replaceWith(newBody);
      this.querySelector('.ch-pdp-specifications').hidden = false;
      if (extra) this.querySelector('.ch-pdp-specifications').after(extra);
      this.dataset.layout = 'structured';
    }
  }
  customElements.define('chronoera-product-details', ChronoeraProductDetails);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
